export default "__VITE_ASSET__586b39f7__"